import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status"]
  connect() {
    console.log("Timeslots Stimulus controller connected")

  }
  toggleStatus(event) {
    const button = event.currentTarget
    const timeslotId = button.dataset.timeslotId
    const actionType = button.dataset.actionType // 'block', 'unblock', 'booked'

    fetch(`/timeslots/${timeslotId}/${actionType}`, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      },
      credentials: 'same-origin'
    })
    .then(response => response.text())
    .then(html => Turbo.renderStreamMessage(html))
  }
}
